import GameParameterInterface from '@/models/game/parameters/interface'
import { SlotLotteryParameter } from '@/models/game/parameters/slot'
import { Property } from '@/models/game/property'
import GameExecutorInterface from '@/services/game/executor/executor-interface'
import GameProcessor from '@/services/game/processor'
import { ScriptLoader } from '@/util/scriptLoader'

export default class SlotGameExecutor implements GameExecutorInterface {

  constructor(
    private processor: GameProcessor,
    private property: Property,
    private parameter: GameParameterInterface
  ) { }

  async execute(): Promise<void> {

    const scriptLoader = new ScriptLoader({
      src : this.property.scriptUrl,
      global: 'GAME',
    })

    const game: any = await scriptLoader.load()

    const slotParameter: SlotLotteryParameter = this.parameter.createSetOption()

    game.setOption({
      parameter: {
        image: slotParameter.prize.prizeImage,
        grade: slotParameter.grade,
      },
      resource: `${this.property.resourcePath}`,
      theme: `${this.processor.gameOrganizer}/${this.property.theme}`,
      nextPageUrl: this.processor.makeGameResultUrl(),
    })
    game.setStarted(() => {

      if (!this.processor.playStatusIsStarted) {
        return this.processor.notifyGameStart({})
      }
    })
    game.setCompleted(() => {

      return this.processor.notifyGameComplete()
    })
    game.start()
  }
}
